module.exports = __webpack_public_path__ + "static/assets/5df880e30f627a6836a7cdeb14b74e3a.svg";